import {parseDate} from './parse-date'
import {parseTime} from './parse-time'

/**
 * Support formats by default:
 * YYYY-MM-DD, MM/DD/YYYY, DD.MM.YYYY, DD.MM.YY
 * if format doesn't support then Date.parse will be applied
 */
export const parseDateTime = (input?: string): number | undefined => {
  if (!input) {
    return undefined
  }

  const [dateInput, timeInput = ''] = input.split(' ')

  const date = parseDate(dateInput)
  if (!date) {
    // process other cases
    return Date.parse(input)
  }

  const time = parseTime(timeInput)

  const dateTime = new Date()
  dateTime.setDate(date.day)
  dateTime.setMonth(date.month - 1)
  dateTime.setFullYear(date.year)

  dateTime.setHours(time.hour)
  dateTime.setMinutes(time.minutes)
  dateTime.setSeconds(time.seconds)
  dateTime.setMilliseconds(0)

  return dateTime.getTime()
}
